/**
 * ErrorVenta.js
 * @author Jaiván Piña
 */

//Dependencies
import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux'
import $ from 'jquery';

//material-ui
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

// Components
import { onBoardingDigital } from '../../../actions/actions'

//Assets
import faceError from '../../../static/img/face-error.png';
import Legal from '../Legal';

//Services
import { processIdClientAnalytics } from './../services/pixelService';
import { Layout } from '../layout/Layout';

class ErrorVenta extends Component {
    constructor(props) {
        super(props);
        this.state = { }
    }
    
    componentDidMount() {
        $(".load").fadeOut(700);
    }

    componentWillMount() {
        processIdClientAnalytics('error-venta');
    }

    render() {
        const footer = {
            button: {
                link: "https://www.hipotecario.com.ar/personas/sucursales-y-cajeros/",
                text : "conocé las sucursales"
            }
        };
        const body = { img : { src : faceError } }
        return (
            <Layout footer={footer} body={body}
                tieneFooter>
                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Grid item xs={12}>
                        <div className="content-description">
                            <h5 className="title" >Tu solicitud no puede ser <br/>
                            procesada</h5>
                            <h6 className="description"> por no cumplir con alguna de las condiciones establecidas. </h6>
                        </div>
                    </Grid>
                </Grid>
            </Layout>
        );
    }
}

export default connect()(ErrorVenta);



// WEBPACK FOOTER //
// ./src/components/OnBoarding/error/ErrorVenta.js